import Email from 'assets/images/email.png';
import Logo from 'assets/images/logo_new.svg';
import Phone from 'assets/images/phone.png';
import Instagram from 'assets/images/social_instagram.png';
import Twitter from 'assets/images/social_twitter.png';
import Youtube from 'assets/images/social_youtube.png';
import moment from 'moment-jalaali';
import { useTranslation } from 'react-i18next';
import Styled from './styles';

moment.loadPersian({ dialect: 'persian-modern' });

const Footer = () => {
  const { t } = useTranslation('layouts');

  return (
    <Styled.Container id="footer">
      <div className={'top'}>
        <Styled.Content>
          <div className={'menus'}>
            <Styled.Menu>
              <Styled.Item
                to={{
                  pathname:
                    'https://www.azarakhshsolar.ir/%d8%af%d8%b1%d8%a8%d8%a7%d8%b1%d9%87-%d9%85%d8%a7/'
                }}
                target="_blank"
              >
                {t('footer.menu.about')}
              </Styled.Item>
              <Styled.Menu>
                <Styled.Item
                  to={{
                    pathname:
                      'https://www.azarakhshsolar.ir/%d8%b3%d9%88%d9%84%d8%a7%d8%aa-%d9%85%d8%aa%d8%af%d8%a7%d9%88%d9%84/'
                  }}
                  target="_blank"
                >
                  {t('footer.menu.faq')}
                </Styled.Item>
              </Styled.Menu>
            </Styled.Menu>
          </div>
          <Styled.Contact>
            <img className="logoSection" src={Logo} alt={''} />
            <div className={'address'}>{t('footer.contact.address')}</div>
            <div className={'social'}>
              <a
                href={'https://instagram.com/'}
                target={'_blank'}
                rel={'noreferrer'}
              >
                <img src={Instagram} alt={''} />
              </a>
              <a
                href={'https://twitter.com'}
                target={'_blank'}
                rel={'noreferrer'}
              >
                <img src={Twitter} alt={''} />
              </a>
              {/* <a
                href={'https://linkedin.com'}
                target={'_blank'}
                rel={'noreferrer'}
              >
                <img src={Linkedin} alt={''} />
              </a> */}
              <a
                href={'https://www.aparat.com/'}
                target={'_blank'}
                rel={'noreferrer'}
              >
                <img src={Youtube} alt={''} />
              </a>
            </div>
          </Styled.Contact>
        </Styled.Content>
      </div>
      <div className={'bottom'}>
        <div className={'copy'}>{`${moment().jYear()} ${t(
          'footer.copyright'
        )}`}</div>
        <div className={'contact'}>
          <div className={'item'}>
            <img src={Phone} alt={''} />
            {t('footer.phone')}
          </div>
          <div className={'item'}>
            <img src={Email} alt={''} />
            {t('footer.email')}
          </div>
        </div>
      </div>
    </Styled.Container>
  );
};

export default Footer;
